import { PipelineNode, PipelineNodeRelationship } from "@models/pipelineNode";
import { getGroupValueForNodeType } from "./modeling.service";
import { usePipelineNodeRelationships } from "@stores/data.store";

interface NodeAlert {
    title: string;
    description: string;
    time: Date;
    type: string;
    objectId: string;
    objectType: 'pipeline_node';
    alertType: 'info' | 'error' | 'warning';
}
export const validateNode = (node: PipelineNode, relationships: PipelineNodeRelationship[]) => {
    const errors: NodeAlert[] = [];
    if (getGroupValueForNodeType(node.node_type) === 'DATA_MODELING') {
        const relationshipsForThisNode = relationships.filter(r => r.parent_node_id === node.id || r.child_node_id === node.id);
        if (relationshipsForThisNode.length === 0) {
            errors.push({
                title: 'Missing relationships',
                description: 'This entity has no relationships to other entities. You should connect it to the rest of your data model.',
                time: node.last_updated || new Date(),
                type: 'MISSING_RELATIONSHIPS',
                objectId: node.id as string,
                objectType: 'pipeline_node',
                alertType: 'warning',
            });
        }
    }

    if (!['SOURCE', 'CUSTOM', 'REPORT', 'DATE_DIMENSION'].includes(node.node_type) && node.upstream_node_ids.length === 0) {
        errors.push({
            title: 'Missing source data',
            description: '',
            time: node.last_updated || new Date(),
            type: 'MISSING_MAPPINGS',
            objectId: node.id as string,
            objectType: 'pipeline_node',
            alertType: 'warning',
        });
    }

    // Check for a build error
    if (node.build_status === 'error') {
        errors.push({
            title: 'Build error',
            description: node.build_error as string,
            time: node.last_updated || new Date(),
            type: 'BUILD_ERROR',
            objectId: node.id as string,
            objectType: 'pipeline_node',
            alertType: 'error',
        });
    }

    if (node.has_duplicate_plb_uuids) {
        errors.push({
            title: 'Duplicate PLB_UUIDs',
            description: 'This custom DBT model has duplicate _PLB_UUID values, which may cause ambiguous relationships in downstream processes.',
            time: node.last_updated || new Date(),
            type: 'DUPLICATE_PLB_UUIDS',
            objectId: node.id as string,
            objectType: 'pipeline_node',
            alertType: 'warning',
        });
    }
    return errors;
}

export const useValidationErrorsForNode = (node: PipelineNode) => {
    const relationships = usePipelineNodeRelationships();
    return validateNode(node, relationships.data || []);
}